/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SegmentAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to send tracking (segment) data to glass.
 */
define([], () => {
	class SegmentAPI {

		/**
		 * @function SegmentAPI#track
		 * @description send the track event to glass with the required data
		 * @param {string} action event action
		 */
		track() { }

		/**
		 * @function SegmentAPI#getInfo
		 * @description collect the required data
		 * @returns {object} tracking data for Segment
		 */
		getInfo() { }

		/**
		 * @function SegmentAPI#registerInfoCallback
		 * @description register info callback
		 * @param {function} cb info callback to register
		 */
		registerInfoCallback() { }

		/**
		 * @function SegmentAPI#unregisterInfoCallback
		 * @description unregister info callback
		 */
		unregisterInfoCallback() { }

	}

	return SegmentAPI;
});
